




import { Component, Prop, Vue } from "vue-property-decorator";
import { InvoiceCategoryCode } from "@/models/invoices";
import { InvoiceStatus } from "@/data/enums/invoice";

@Component({
  components: {
    "date-range-stat": () =>
      import("@/components/app/global/stats/_dateRangeStat.vue")
  }
})
export default class InvoicesTotal extends Vue {
  // Props
  @Prop({ default: () => [] })
  public readonly invoiceCategories!: InvoiceCategoryCode[];

  @Prop({ default: null })
  public readonly invoiceStatus!: InvoiceStatus;

  // Getters
  public get attrs() {
    return this.$_.merge(
      {
        id: "invoicesStats",
        label: this.$t("_.total_invoices"),
        scope: "invoices",
        params: {
          type: "invoices",
          date_to: this.$moment().format("YYYY-MM-DD"),
          ...this.params
        },
        valuePath: `total.result.{currencyCode}[0].count`,
        valueFunc: this.calcValue,
        tooltipMessage: this.$t("_sentence.number_of_all_invoices")
      },
      this.$attrs
    );
  }

  public get params() {
    const params = {};
    if (this.invoiceCategories.length)
      params["invoice_category"] = `[${this.invoiceCategories
        .map(i => `"${i}"`)
        .join()}]`;
    if (this.invoiceStatus) params["report"] = `["${this.invoiceStatus}"]`;

    return params;
  }

  // Methods
  public async calcValue({ data, defaultValue }) {
    if (!data) return defaultValue;
    return data;
  }
}
